import React from 'react'
import { useList, ListProps } from './useList'
import styles from './List.module.scss'
import NewsCard from 'components/NewsCard/NewsCard'

const List: React.FC<ListProps> = (props: ListProps) => {
  const { news, isAr, selectedLanguage, t } = useList(props)

  return (
    <div className={`${styles['news-list']} row`}>
      {news && news.length ? (
        news.map((news, index) => {
          const description = isAr ? news.descriptionAr : news.descriptionEn
          let shortDescription = ''

          if (
            description &&
            description.length > 0 &&
            description[0].children &&
            description[0].children.length > 0
          ) {
            const firstText = description[0].children[0].text
            shortDescription = `${firstText.substring(0, 100)}...`
          } else shortDescription = t('noDetails')

          return (
            <div
              key={`news-${news.id}-${index}`}
              className='col-12 col-md-6 col-lg-4 mb-3'
            >
              <NewsCard
                image={news.image}
                title={isAr ? news.titleAr : news.titleEn}
                description={shortDescription}
                author={isAr ? news.author.nameAr : news.author.nameEn}
                authorImage={news.author.photo}
                category={isAr ? news.category.nameAr : news.category.nameEn}
                url={`/${selectedLanguage}/NewsDetails/${news.slugAr}`}
                date={news.publishedAt.split('T')[0]}
                isAr={isAr}
                t={t}
              />
            </div>
          )
        })
      ) : (
        <div className={`col-12 text-center ${styles['no-data']} fs-4 fw-bold`}>
          {t('noData')}
        </div>
      )}
    </div>
  )
}

export default List
